<h2 mat-dialog-title class="av-section-title">
  {{ 'backoffice.licences.assign.title' | translate }}
</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0">{{ 'backoffice.licences.assign.hint' | translate }}</p>

  <dl class="d-flex flex-column gap-2 m-0">
    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.common.reason_dialog.organization' | translate }}</dt>
      <dd class="m-0 cell-strong text-end" data-testid="assign-organization">
        {{ data.organizationName }}
      </dd>
    </div>

    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.licences.assign.licence' | translate }}</dt>
      <dd class="m-0 text-end av-source">{{ data.licenceLabel }}</dd>
    </div>
  </dl>

  @if (assignableUsers.length === 0) {
    <div class="av-banner p-3 d-flex align-items-start gap-2" data-testid="assign-no-users">
      <mat-icon aria-hidden="true">person_off</mat-icon>
      <span>{{ 'backoffice.licences.assign.no_users' | translate }}</span>
    </div>
  }

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="assign-user">
      <span class="av-meta">{{ 'backoffice.licences.assign.user' | translate }}</span>
      <select id="assign-user" class="av-field" formControlName="user_id" data-testid="assign-user">
        <option value="">{{ 'backoffice.licences.assign.pick_user' | translate }}</option>
        @for (user of assignableUsers; track user.id) {
          <option [value]="user.id">{{ user.fullName }} — {{ user.email }}</option>
        }
      </select>
    </label>

    <label class="d-flex flex-column gap-1" for="assign-reason">
      <span class="av-meta">{{ 'backoffice.licences.reason' | translate }}</span>
      <textarea
        id="assign-reason"
        class="av-field"
        rows="3"
        [attr.maxlength]="reasonMax"
        formControlName="reason"
        data-testid="assign-reason"
      ></textarea>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="dismiss()">
    {{ 'backoffice.common.actions.cancel' | translate }}
  </button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid"
    (click)="confirm()"
    data-testid="assign-submit"
  >
    {{ 'backoffice.licences.assign.submit' | translate }}
  </button>
</mat-dialog-actions>
